import { render, staticRenderFns } from "./MoleculeEditionAssetContents.vue?vue&type=template&id=2144b883&"
import script from "./MoleculeEditionAssetContents.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAssetContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports